<app-header (modalTypeEvent)="getModalType($event)"></app-header>
<div class="content-container">
    <div class="left">
        <app-account-information [cargoPaymentInfo]="cargoPaymentInfo"></app-account-information>    
        <app-contract-acceptance [cargoPaymentInfo]="cargoPaymentInfo"></app-contract-acceptance>
        <app-payment [cargoPaymentInfo]="cargoPaymentInfo" (modalTypeEvent)="getModalType($event)"></app-payment>
        <app-payment-summary [cargoPaymentInfo]="cargoPaymentInfo"></app-payment-summary>
    </div>
        <div class="right">
        <app-message-box [cargoPaymentInfo]="cargoPaymentInfo"></app-message-box>
    </div>
</div>
<app-footer [cargoPaymentInfo]="cargoPaymentInfo" [paymentTransactionComponent]="paymentTransactionComponent" [inputParametersValidationResult]="inputParametersValidationResult" (modalTypeEvent)="getModalType($event)"></app-footer>
<app-modal [cargoPaymentInfo]="cargoPaymentInfo" [modalType]="modalType"></app-modal>

